<!-- Notification Container - Fixed positioning for top-right corner -->
@if (currentNotification) {
  <div class="notification-container" 
       [ngClass]="getTypeClass()" 
       [attr.data-notification-id]="currentNotification.id"
       [attr.data-notification-type]="currentNotification.type"
       (mouseenter)="pauseDismiss()"
       (mouseleave)="resumeDismiss()">
    <div class="notification-content">
      <div class="notification-icon">
        <span class="icon">{{ getIcon() }}</span>
      </div>
      <div class="notification-message">
        <div class="message-text" [title]="currentNotification.message">{{ currentNotification.message }}</div>
        @if (currentNotification.details && currentNotification.details.length > 0) {
          <div class="message-details">
            @for (detail of currentNotification.details; track detail.label) {
              <div class="detail-item" #detailEl>
                <span class="detail-label">{{ detail.label }}:</span>
                <span class="detail-value"
                      [title]="(detail.originalValue ?? detail.value).toString()">{{ detail.value }}</span>
              </div>
            }
          </div>
        }
      </div>
      <button class="notification-close" (click)="dismiss()" aria-label="Close notification">
        ×
      </button>
    </div>
  </div>
}
